export enum ContractTypeEnum {
  Vehicle = 1,
  Home = 2,
}

export const ContractTypeDisplayName = {
  [ContractTypeEnum.Vehicle]: 'Vehicle',
  [ContractTypeEnum.Home]: 'Home',
};
